import type { Payments_PaymentProcessorId as PaymentProcessorId } from '__generated__/graphql-types';

import type { PaymentProcessorType } from 'bundles/payments-common/common/PaymentProcessorTypes';
import { getPaymentProcessorId } from 'bundles/payments-common/utils/paymentProcessorUtils';
import { STRIPE_PAYMENT_PROCESSOR_TYPES } from 'bundles/payments-common/utils/stripeUtils';

const normalizePaymentProcessor = (paymentProcessor: PaymentProcessorType | PaymentProcessorId) =>
  getPaymentProcessorId(paymentProcessor) ?? paymentProcessor;

const STRIPE_PAYMENT_PROCESSOR_IDS = STRIPE_PAYMENT_PROCESSOR_TYPES.map(normalizePaymentProcessor);

// Normalize GraphQL and Naptime values to Scala IDs, preserving unmapped values for direct comparison.
export const isStripePaymentProcessor = <T extends PaymentProcessorType | PaymentProcessorId>(
  paymentProcessor?: T | null
) => {
  const paymentProcessorId = paymentProcessor && normalizePaymentProcessor(paymentProcessor);
  return Boolean(paymentProcessorId && STRIPE_PAYMENT_PROCESSOR_IDS.includes(paymentProcessorId));
};
